var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2610148(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_33572_63699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 38,
    height: 38,
    rx: 19,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0007 42.6666C49.4173 42.6666 54.6673 37.4166 54.6673 30.9999C54.6673 24.5833 49.4173 19.3333 43.0007 19.3333C36.584 19.3333 31.334 24.5833 31.334 30.9999C31.334 37.4166 36.584 42.6666 43.0007 42.6666Z",
    stroke: "url(#paint0_linear_33572_63699)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6992 34.3016L46.3026 27.6982",
    stroke: "url(#paint1_linear_33572_63699)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3026 34.3016L39.6992 27.6982",
    stroke: "url(#paint2_linear_33572_63699)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_33572_63699",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.3125 0 0 0 0 0.3125 0 0 0 0 0.3125 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_33572_63699"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_33572_63699",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33572_63699",
    x1: 48.953,
    y1: 63.4999,
    x2: 64.5653,
    y2: 61.0602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1741BC",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33572_63699",
    x1: 44.6854,
    y1: 40.1974,
    x2: 49.1037,
    y2: 39.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1741BC",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33572_63699",
    x1: 44.6854,
    y1: 40.1974,
    x2: 49.1037,
    y2: 39.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1741BC",
    stopOpacity: 0.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2610148);
export default __webpack_public_path__ + "static/media/Frame 2610148.a404d289460445ba75c25e2144a30178.svg";
export { ForwardRef as ReactComponent };